var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("pre", { pre: true }, [
        _c("code", { attrs: { "v-pre": "", class: "language-html" } }, [
          _c("span", { attrs: { class: "hljs-tag" } }, [
            _vm._v("<"),
            _c("span", { attrs: { class: "hljs-name" } }, [_vm._v("template")]),
            _vm._v(">")
          ]),
          _vm._v("\n  "),
          _c("span", { attrs: { class: "hljs-tag" } }, [
            _vm._v("<"),
            _c("span", { attrs: { class: "hljs-name" } }, [_vm._v("div")]),
            _vm._v(">")
          ]),
          _vm._v("\n    "),
          _c("span", { attrs: { class: "hljs-tag" } }, [
            _vm._v("<"),
            _c("span", { attrs: { class: "hljs-name" } }, [_vm._v("h5")]),
            _vm._v(">")
          ]),
          _vm._v("Enter your email, we will send you product menu"),
          _c("span", { attrs: { class: "hljs-tag" } }, [
            _vm._v("</"),
            _c("span", { attrs: { class: "hljs-name" } }, [_vm._v("h5")]),
            _vm._v(">")
          ]),
          _vm._v("\n    "),
          _c("span", { attrs: { class: "hljs-tag" } }, [
            _vm._v("<"),
            _c("span", { attrs: { class: "hljs-name" } }, [_vm._v("input")]),
            _vm._v(" "),
            _c("span", { attrs: { class: "hljs-attr" } }, [_vm._v("type")]),
            _vm._v("="),
            _c("span", { attrs: { class: "hljs-string" } }, [_vm._v('"text"')]),
            _vm._v(" "),
            _c("span", { attrs: { class: "hljs-attr" } }, [_vm._v("class")]),
            _vm._v("="),
            _c("span", { attrs: { class: "hljs-string" } }, [
              _vm._v('"form-control"')
            ]),
            _vm._v("\n      "),
            _c("span", { attrs: { class: "hljs-attr" } }, [
              _vm._v("@keyup.enter")
            ]),
            _vm._v("="),
            _c("span", { attrs: { class: "hljs-string" } }, [
              _vm._v("\"$emit('commitAccept')\"")
            ]),
            _vm._v("\n      "),
            _c("span", { attrs: { class: "hljs-attr" } }, [_vm._v("v-model")]),
            _vm._v("="),
            _c("span", { attrs: { class: "hljs-string" } }, [
              _vm._v('"localData"')
            ]),
            _vm._v(">")
          ]),
          _vm._v("\n  "),
          _c("span", { attrs: { class: "hljs-tag" } }, [
            _vm._v("</"),
            _c("span", { attrs: { class: "hljs-name" } }, [_vm._v("div")]),
            _vm._v(">")
          ]),
          _vm._v("\n"),
          _c("span", { attrs: { class: "hljs-tag" } }, [
            _vm._v("</"),
            _c("span", { attrs: { class: "hljs-name" } }, [_vm._v("template")]),
            _vm._v(">")
          ]),
          _vm._v("\n\n"),
          _c("span", { attrs: { class: "hljs-tag" } }, [
            _vm._v("<"),
            _c("span", { attrs: { class: "hljs-name" } }, [_vm._v("script")]),
            _vm._v(">")
          ]),
          _c("span", { attrs: { class: "actionscript" } }, [
            _vm._v("\nexport "),
            _c("span", { attrs: { class: "hljs-keyword" } }, [
              _vm._v("default")
            ]),
            _vm._v(" {\n  props: {\n    data: {\n      "),
            _c("span", { attrs: { class: "hljs-keyword" } }, [
              _vm._v("default")
            ]),
            _vm._v(": "),
            _c("span", { attrs: { class: "hljs-literal" } }, [_vm._v("null")]),
            _vm._v(",\n    },\n  },\n  data() {\n    "),
            _c("span", { attrs: { class: "hljs-keyword" } }, [
              _vm._v("return")
            ]),
            _vm._v(" {\n      localData: "),
            _c("span", { attrs: { class: "hljs-literal" } }, [_vm._v("null")]),
            _vm._v(
              ",\n    }\n  },\n  watch: {\n    localData(value) {\n      "
            ),
            _c("span", { attrs: { class: "hljs-keyword" } }, [_vm._v("this")]),
            _vm._v(".$emit("),
            _c("span", { attrs: { class: "hljs-string" } }, [
              _vm._v("'updateData'")
            ]),
            _vm._v(", value)\n    },\n    data(value) {\n      "),
            _c("span", { attrs: { class: "hljs-keyword" } }, [_vm._v("this")]),
            _vm._v(".localData = value\n    },\n  },\n}\n")
          ]),
          _c("span", { attrs: { class: "hljs-tag" } }, [
            _vm._v("</"),
            _c("span", { attrs: { class: "hljs-name" } }, [_vm._v("script")]),
            _vm._v(">")
          ]),
          _vm._v("\n")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4ceee16d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ceee16d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-markdown-loader/lib/markdown-compiler.js?raw!./src/Resource/Example/CustomeComponent/FormComponent.md
// module id = null
// module chunks = 